// Global
import React from 'react';

// Local
import styles from './RecipeSeo.module.scss';
import EnhancedRichText from 'components/helpers/Atoms/EnhancedRichText/EnhancedRichText';
import { KitchenTip } from 'lib/services/models/content-response';
import { RecipeTipShot } from '../../RecipeTipShot/RecipeTipShot';

export interface RecipeSeoProps {
  content?: KitchenTip[];
  title?: string;
  seoContentSettings?: {
    hideSEOContent?: boolean;
  };
}

export function RecipeSeo(props: RecipeSeoProps) {
  const { content, title } = props;

  return (
    <div className={`${styles.recipeSeoWrapper}`}>
      {content?.map((tip, index) => {
        const tipShot = tip.TipShots?.[0];
        return (
          <div key={index} className={styles.recipeSeoItem}>
            <h2>{tip.Title || title}</h2>
            <EnhancedRichText value={tip.Description} />
            <RecipeTipShot tipShot={tipShot} />
          </div>
        );
      })}
    </div>
  );
}
